// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draggable-component{-webkit-transform:translate(0);transform:translate(0)}", ""]);
// Exports
module.exports = exports;
